import React, { useState, useEffect } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import './Welcome.css';
import config from "../../config";
import { getProjectCategory, getProjectApi, getItemListSize, putProjectViewCount } from "../../api";
const Welcome = () => {



  return (
    <section className="welcome-section py-4">
      <Container>
        <Row className="align-items-start ">
          <Col md={4}>
            <div className="welcome-image-container mt-2">
              <img
                src="images/turksa/turksaAnasayfa.png"
                alt="Türk Sanatında Sanatçılar Ansiklopedisi"
                className="welcome-image"
              />
            </div>
          </Col>
          <Col md={8}>
            <h2 className="welcome-title">Türk Sanatında Sanatçılar Ansiklopedisi Projesi’ne Hoş Geldiniz</h2>
            <div className="welcome-text">
              <p>
              Türk kültürünü bilimsel yöntemlerle araştırmak, tanıtmak, yaymak ve bu alandaki kişi ve kuruluşları destekleyip
onlarla işbirliği yapmak misyonu ve Türk kültürü araştırmalarında ulusal ve uluslararası düzeyde en yetkin
Kurumlardan biri olmak ve temel değerleri yaşatarak millî kültürümüzü çağdaş medeniyetler seviyesi üzerine
çıkarmak vizyonunu göz önünde bulundurarak, “Türk Sanatında Sanatçılar Ansiklopedisi” başlığı altında, Türk
sanatı tarihi ve kültürel mirasımıza katkıda bulunulması ve elde edilecek bilgilerin toplumun bütün kesimlerinin
kolaylıkla erişimine imkân verecek güvenilir bir açık kaynağa dönüştürülmesi amacıyla elektronik ortamda
yayımlanması ve yeni tarihî veriler ışığında sürekli güncellenebilmesi amaçlanmıştır.
              </p>
              <p>
              “Türk Sanatında Sanatçılar” adlı projede, ilk aşamada, Türkiye’de, Selçuklu çağından ve 11. yüzyıldan
başlayarak Osmanlı çağının sonuna ve 1923 yılına kadar uzanan kronolojik bir sınır dâhilinde adları ve/veya
eserleri bilinen sanatçılara yer verilecektir. Cumhuriyetimizin ilân edildiği 1923 yılından günümüze kadar uzanan
tarihî süreç ise “Cumhuriyet Dönemi Türk Sanatı”nı konu edinen projede kapsamlı olarak ele alınacaktır.
              </p>
   
            </div>
            {/* <a href="#details" className="read-more">devamını oku...</a> */}
          </Col>
        </Row>



      </Container>
    </section>
  );
};

export default Welcome; 